import {Component, EventEmitter, inject, OnInit, Output} from "@angular/core";
import {CommonModule} from "@angular/common";
import {ModalService} from "src/app/shared/data-access/modal.service";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule, ValidationErrors,
  Validators,
} from "@angular/forms";
import {ModalComponent} from "../modal.component";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {KnowledgeBaseService} from "src/app/features/knowledge-database/data-access/knowledge-base.service";
import {EditTreeItemService} from "src/app/features/knowledge-database/data-access/edit-tree-item.service";
import {ReportService} from "src/app/features/error-report/data-access/report.service";

@Component({
  selector: "app-item-form-modal",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ModalComponent,
    MatInputModule,
    MatFormFieldModule,
  ],
  template: `
    <app-modal modalId="itemFormModal" (closeModal)="closeModal()">
      <ng-container>
        <h1>{{ editTreeItemService.modalHeading() }}</h1>

        <form [formGroup]="itemForm" class="item-form">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Bezeichnung</mat-label>
            <input matInput type="text" formControlName="name"/>
            <mat-error
              *ngIf="name?.errors?.['required'] || name?.errors?.['noEmptyString']">
              Bezeichnung ist erforderlich.
            </mat-error>
          </mat-form-field>
          <!-- <mat-form-field
            *ngIf="
              editTreeItemService.action() === 'addMalfunction' ||
              editTreeItemService.action() === 'editMalfunction'
            "
            appearance="outline"
            class="w-100"
          >
            <mat-label>Beschreibung</mat-label>
            <input matInput type="text" formControlName="description" />
          </mat-form-field> -->
        </form>

        <button class="btn btn-qundis-primary mt-4" (click)="onSubmit()">
          Speichern
        </button>
      </ng-container>
    </app-modal>
  `,
  styles: [
    `
      .item-form {
        display: flex;
        flex-direction: column;
      }
    `,
  ],
})
export class ItemFormModalComponent implements OnInit {
  modalService = inject(ModalService);
  knowledgeBaseService = inject(KnowledgeBaseService);
  reportService = inject(ReportService);
  editTreeItemService = inject(EditTreeItemService);
  formBuilder = inject(FormBuilder);

  itemForm: FormGroup = this.formBuilder.group({
    name: ["", [Validators.required, this.noEmptyStringValidator]],
  });

  get name() {
    return this.itemForm.get('name');
  }

  ngOnInit() {
    if (this.editTreeItemService.itemBeingEdited()) {
      this.itemForm.patchValue({
        name: this.editTreeItemService.itemBeingEdited()?.name,
      });
    }
  }

  private noEmptyStringValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (typeof value === 'string' && value.trim().length === 0) {
      return {noEmptyString: true};
    }
    return null;
  }

  openModal() {
    this.modalService.openModal("itemFormModal");
  }

  closeModal() {
    this.modalService.closeModal("itemFormModal");
    this.editTreeItemService.itemBeingEdited$.next(null);
  }

  onSubmit() {
    if (this.itemForm.invalid) {
      this.itemForm.markAllAsTouched();
      return;
    }
    if (this.editTreeItemService.action()?.includes("add")) {
      this.editTreeItemService.addItem(this.itemForm.value);
    } else if (this.editTreeItemService.action()?.includes("edit")) {
      this.editTreeItemService.updateItem(this.itemForm.value);
    }

    this.closeModal();
  }
}
